import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { appConfig } from '~/app.config';

@Pipe({
  name: 'totalResults',
})
export class TotalResultsPipe implements PipeTransform {
  constructor(private readonly translateService: TranslateService) {}

  transform(total: number): string {
    // if the API returns the maximum it can count, we assume there are more items
    const formattedTotal =
      total >= appConfig.apiMaxLimit ? `${appConfig.apiMaxLimit}+` : total;
    const key =
      total > 1
        ? 'attendee.result_page.activites_results'
        : 'attendee.result_page.activites_result';
    const translation = this.translateService.instant(key);

    return `${formattedTotal} ${translation}`;
  }
}
